export const enum IconNames {
  Trash
}

export type IconProps = {
  name: IconNames
  colour: string;
}